import type { DialogProps } from '@mui/material/Dialog';
import type { SxProps, Theme } from '@mui/material/styles';

import { useState } from 'react';

import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Counter } from 'src/components/counter/counter';
import type { UseSeatCountReturn } from './use-seat-count';

// ----------------------------------------------------------------------

export type Props = DialogProps & UseSeatCountReturn & { onSubmit?: (data: number) => void };

export function DialogSeatCountField({
  open,
  onClose,
  onSubmit,
  /********/
  seatCount,
  onChangeSeatCount,
  /********/
  PaperProps,
  title = 'Dialog Title',
  ...other
}: Props) {
  const handleSubmit = () => {
    onClose();
    onSubmit?.(counter);
  };

  const [counter, setCounter] = useState(seatCount ?? 1);

  const contentStyles: SxProps<Theme> = {
    py: 1,
    gap: 3,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        ...PaperProps,
        sx: [...(Array.isArray(PaperProps?.sx) ? (PaperProps?.sx ?? []) : [PaperProps?.sx])],
      }}
      {...other}
    >
      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

      <DialogContent>
        <Box sx={contentStyles}>
          <div className="flex flex-col gap-[10px]">
            <div className="flex justify-between">
              <Typography variant="subtitle2">Kursi</Typography>
              <Counter
                value={counter}
                onChange={(v) => {
                  setCounter(v);
                }}
              />
            </div>
            <Typography variant="caption">Anak dengan bdan 90cm harus memiliki tiket.</Typography>
          </div>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Batal
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Simpan
        </Button>
      </DialogActions>
    </Dialog>
  );
}
